import script from "./MarketView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarketView.vue?vue&type=script&setup=true&lang=ts"

import "./MarketView.vue?vue&type=style&index=0&id=688a9967&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-688a9967"]])

export default __exports__